module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "settlementReceiptView"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-default"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printSettlementReceiptView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printSettlementReceiptView"
    }
  }, [(_vm.seeRecordSettlement) ? _c('div', {
    staticClass: "row printing"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.$store.state.settingRecord) ? _c('p', {
    staticClass: "text-bold text-center"
  }, [_vm._v(_vm._s(_vm.$store.state.settingRecord.companyName) + " "), _c('br'), _vm._v(" Settlement Details")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed center"
  }, [_c('thead', [(_vm.seeRecordSettlement.branch) ? _c('tr', [_c('td', [_vm._v("Branch")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.branch.name))])]) : _vm._e()]), _vm._v(" "), _c('tbody', [(_vm.seeRecordSettlement.created_by) ? _c('tr', [_c('td', [_vm._v("Created By")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.created_by.name) + " "), (_vm.seeRecordSettlement.created_by.code) ? _c('span', [_vm._v("( " + _vm._s(_vm.seeRecordSettlement.created_by.code) + " )")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("myDate")(_vm.seeRecordSettlement.sattlementDate)))])]), _vm._v(" "), (_vm.seeRecordSettlement.type) ? _c('tr', [_c('td', [_vm._v("Type")]), _vm._v(" "), (_vm.seeRecordSettlement.type === 'panulty') ? _c('td', [_vm._v("penalty")]) : _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.type))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecordSettlement.member_loan_plan) ? _c('tr', [_c('td', [_vm._v("Loan Id")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.member_loan_plan.applicationNo))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecordSettlement.member) ? _c('tr', [_c('td', [_vm._v("Member")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.member.name) + " "), (_vm.seeRecordSettlement.member.code) ? _c('span', [_vm._v("( " + _vm._s(_vm.seeRecordSettlement.member.code) + " )")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.seeRecordSettlement.member) ? _c('tr', [_c('td', [_vm._v("Mobile")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.member.mobile))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total Installment Due")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.totalInstallmentDue))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total Installment Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.totalInstallmentPaid))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Loan Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.planAmount))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Due Amount")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.totalAmountDue))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Due Amount Without Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.totalAmountDueWithoutInterest))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total Amount Paid")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.totalAmountPaid))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total Amount Paid Settlement Time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.totalAmountPaidWithSettlement))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reason")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.reason))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.status))])]), _vm._v(" "), (_vm.seeRecordSettlement.branch_ledger) ? _c('tr', [_c('td', [_vm._v("Payment Mode")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.seeRecordSettlement.branch_ledger.ledger.name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Note: This is a computer‐generated document. No signature is required")])])])])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          CLOSE\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5287570a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/SettlementPrintView.vue
// module id = 875
// module chunks = 0